import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { ServiceCard } from "./ServiceCard";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { refTypesList } from "../../../../redux/actions/dbactions/refactions";
import { getSession } from "../../../../redux/actions/authActions";
import { Header } from "../../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

export const ServicesOpen = () => {
  const [addmodal, setAddmodal] = useState(false);
  const { facilityId } = useParams();
  const { role_id } = getSession();
  const dispatch = useDispatch();

  const { exploreList } = useSelector((state) => state.exploreReducer);
  const exploreService = exploreList?.svc_typ_desc;
  const explorelist = exploreList.usr?.rec || [];

  useEffect(() => {
    dispatch(refTypesList());
  }, [facilityId, dispatch]);
  const filterList = explorelist.find(
    (item) => item.svcf_id === parseInt(facilityId, 10)
  );
  const serViceList = filterList?.services || [];

  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const HandleClick = (id) => {
    setSelectedColor(selectedColor === id ? null : id);
    setIsDisabled(isDisabled === id ? null : id);
  };

  return (
    <div>
      <Header
        pageTitle={`Explore > ${exploreService} > ${
          explorelist?.at(0)?.svcf_name
        } > Services List`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          Services List
        </h5>
        <div className="w-fit whitespace-nowrap">
          {role_id === "3" || role_id === "5" ? (
            ""
          ) : (
            <button
              onClick={() => setAddmodal(true)}
              className="sign_btn !text-xs"
            >
              Add New Service
            </button>
          )}
        </div>
      </div>
      <Row className="sm:!px-4 m-0">
        {serViceList.length > 0 ? (
          serViceList.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <ServiceCard
                data={item}
                HandleClick={() => HandleClick(item.svc_id)}
                selectedColor={selectedColor}
                isDisabled={isDisabled}
                dispatch={dispatch}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Services found</p>
          </Col>
        )}
      </Row>
    </div>
  );
};
